var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ams-info", attrs: { id: "tab-ams" } },
    [
      _vm.showCodeSearch
        ? _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        staticStyle: { "padding-left": "5px" },
                        attrs: { "split-button": "", type: "primary", no: "1" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(this.getItemTitle(_vm.command1)) + " "
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy Last Time",
                                  title: _vm.$t("SeaExport.CopyLast")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy Last Time"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy By File NO",
                                  title: _vm.$t("SeaExport.WaybillNumberCopy")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy By File NO"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          {
            staticClass: "address-format-from",
            staticStyle: { display: "flex" }
          },
          [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.OtherInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Other")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.ams2.gridOptions,
                            "column-defs": _vm.ams2ColumnDefs,
                            "row-data": _vm.ams2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.ams2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    ),
                                    no: "2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnSynchroClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Synchronise HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete"),
                                    no: "4"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title:
                            "ENS " + _vm.$t("SeaExport.DeclarationInformation")
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getItemTitle("ENS Declaration Information")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: {
                          label: _vm.getItemTitle("ENS Declaration Type")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.readonly || _vm.isTradetech,
                              no: "5"
                            },
                            model: {
                              value: _vm.form.declarationType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declarationType", $$v)
                              },
                              expression: "form.declarationType"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "F14", value: "F14" }
                            }),
                            _c("el-option", {
                              attrs: { label: "F15", value: "F15" }
                            }),
                            _c("el-option", {
                              attrs: { label: "F16", value: "F16" }
                            }),
                            _c("el-option", {
                              attrs: { label: "F17", value: "F17" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow(true, true, false),
                            expression: "isShow(true,true,false)"
                          }
                        ],
                        class: _vm.isDifferent(true, true, false),
                        attrs: {
                          label: _vm.getItemTitle("Carrier EORI"),
                          title: _vm.$t("SeaExport.ShippingCompanyEORI")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            cache: false,
                            "allow-create": true,
                            filterable: "",
                            "tag-name": "code",
                            "tag-value": "code",
                            "default-value": _vm.form.carrierEori,
                            "static-options": _vm.localData.carrierEoriList,
                            no: "6"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.carrierEori = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow(false, true, true),
                            expression: "isShow(false,true,true)"
                          }
                        ],
                        staticClass: "blue-text",
                        attrs: {
                          label: _vm.getItemTitle("Declarant EORI"),
                          title: _vm.$t("SeaExport.DeclarantEORI")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            cache: false,
                            "allow-create": true,
                            filterable: "",
                            "tag-name": "code",
                            "tag-value": "code",
                            "default-value": _vm.form.declarantEori,
                            "static-options": _vm.localData.declarantEoriList,
                            no: "7"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.declarantEori = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow(true, true, false),
                            expression: "isShow(true,true,false)"
                          }
                        ],
                        class: _vm.isDifferent(true, true, false),
                        attrs: {
                          label: _vm.getItemTitle("Memberstate"),
                          title: _vm.$t("SeaExport.Memberstate")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "8",
                            "static-options": _vm.declaringCountrys,
                            cache: false,
                            "default-value": _vm.form.declaringMemberCountry,
                            filterable: "",
                            clearable: "",
                            "filter-tag-names": ["code"],
                            "tag-name": "code",
                            "tag-value": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.declaringMemberCountry = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow(true, false, true),
                            expression: "isShow(true, false, true)"
                          }
                        ],
                        class: _vm.isDifferent(true, false, true),
                        attrs: {
                          title: _vm.$t("SeaExport.FLCLType"),
                          label: _vm.getItemTitle("Consignment Type")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("SeaExport.PleaseChoose"),
                              no: "10"
                            },
                            model: {
                              value: _vm.form.containerLoadType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "containerLoadType", $$v)
                              },
                              expression: "form.containerLoadType"
                            }
                          },
                          _vm._l(_vm.consignmentTypes, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.isYitong && _vm.isF16F17),
                            expression: "!(isYitong && isF16F17)"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("Cargo Type"),
                          title: _vm.$t("SeaExport.CargoType")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "11" },
                            model: {
                              value: _vm.form.goodsType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "goodsType", $$v)
                              },
                              expression: "form.goodsType"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("General Cargo"),
                                value: 0
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("Dangerous Cargo"),
                                value: 1
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("Chemical Cargo"),
                                value: 2
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              (_vm.isF16F17 || _vm.isF14) &&
                              _vm.isYitong
                            ),
                            expression: "!((isF16F17 || isF14) && isYitong)"
                          }
                        ]
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: {
                              title: _vm.$t("SeaExport.DeclarationType")
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Declare Type")))]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "12" },
                                model: {
                                  value: _vm.form.frob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "frob", $$v)
                                  },
                                  expression: "form.frob"
                                }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "I",
                                          value: "I"
                                        }
                                      },
                                      [_vm._v("Import")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "F",
                                          value: "F"
                                        }
                                      },
                                      [_vm._v("Freight Remain on Board")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.isYitong && _vm.isF16F17),
                            expression: "!(isYitong && isF16F17)"
                          }
                        ]
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: {
                              title: _vm.$t("SeaExport.ChargesPaymentMethod")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getItemTitle("Charges Payment Method"))
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "blue-text",
                                attrs: { no: "13" },
                                model: {
                                  value: _vm.form.chargesPaymentMethod,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "chargesPaymentMethod",
                                      $$v
                                    )
                                  },
                                  expression: "form.chargesPaymentMethod"
                                }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "A",
                                          value: "A"
                                        }
                                      },
                                      [_vm._v("Payment in cash")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "B",
                                          value: "B"
                                        }
                                      },
                                      [_vm._v("Payment by credit card")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "C",
                                          value: "C"
                                        }
                                      },
                                      [_vm._v("Payment by cheque")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "D",
                                          value: "D"
                                        }
                                      },
                                      [_vm._v("Other")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "H",
                                          value: "H"
                                        }
                                      },
                                      [_vm._v("Electronic credit transfer")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "Y",
                                          value: "Y"
                                        }
                                      },
                                      [_vm._v("Account holder with carrier")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "Z",
                                          value: "Z"
                                        }
                                      },
                                      [_vm._v("Not pre-paid")]
                                    )
                                  ],
                                  1
                                ),
                                _vm.isTradetech
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticStyle: { display: "block" },
                                        attrs: {
                                          effect: "dark",
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              disabled: _vm.readonly,
                                              label: "Wire",
                                              value: "Wire"
                                            }
                                          },
                                          [_vm._v("Wire")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isTradetech
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticStyle: { display: "block" },
                                        attrs: {
                                          effect: "dark",
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              disabled: _vm.readonly,
                                              label: "ACH",
                                              value: "ACH"
                                            }
                                          },
                                          [_vm._v("ACH")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("ens-address-format-form", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !((_vm.isYitong || _vm.isEFreight) && _vm.isF16F17),
                  expression: "!((isYitong || isEFreight) && isF16F17)"
                }
              ],
              staticStyle: { width: "400px", height: "1350px" },
              attrs: {
                job: _vm.job,
                "show-second-notify-party": _vm.showSecondNotifyParty,
                readonly: _vm.readonly,
                "local-data": _vm.localData,
                "address-form": _vm.form.afrAddress[0] || {},
                "tab-name": _vm.tabName,
                "declaration-type": _vm.form.declarationType
              },
              on: {
                showSenderAndReceiverDialog: _vm.showSenderAndReceiverDialog,
                selectionItemHandlerByType: function(p) {
                  _vm.pm.selectionItemHandlerByType(p)
                }
              }
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isF14,
                    expression: "!isF14"
                  }
                ],
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "title",
                    attrs: {
                      title: _vm.$t("SeaExport.BuyerAndSellerInformation")
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getItemTitle("Buyer and Seller Information"))
                    )
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-position": "right",
                      "label-width": "110px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Seller") } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "vertical-align": "top" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "14",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyAddress("Seller")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyConsignor")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.Name") } },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.form.frob === "I"
                                ? _vm.isDifferent(true, true, true)
                                : "",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Name")))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "15"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "seller",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.sellerName,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "sellerName", $$v)
                            },
                            expression: "addressForm.sellerName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.Addr") + "1" } },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.form.frob === "I"
                                ? _vm.isDifferent(true, true, true)
                                : "",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address") + "1"))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "16"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "seller",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.sellerAddress1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "sellerAddress1", $$v)
                            },
                            expression: "addressForm.sellerAddress1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Address") + "2",
                          title: _vm.$t("SeaExport.Addr") + "2"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address") + "2"))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "17"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "seller",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.sellerAddress2,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "sellerAddress2", $$v)
                            },
                            expression: "addressForm.sellerAddress2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isTradetech,
                            expression: "!isTradetech"
                          }
                        ],
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(true, true, true)
                            : "",
                        attrs: { label: _vm.getItemTitle("Street No") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "18" },
                          model: {
                            value: _vm.addressForm.sellerStreetNo,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "sellerStreetNo", $$v)
                            },
                            expression: "addressForm.sellerStreetNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, false, true)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("Country"),
                          title: _vm.$t("SeaExport.Country")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "19",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Country,
                                cache: false,
                                filterable: "",
                                "default-value": _vm.addressForm.sellerCountry,
                                "filter-tag-names": [
                                  "code",
                                  "chineseName",
                                  "name"
                                ],
                                "tag-name": "code",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.addressForm.sellerCountry = p.value
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.form.frob === "I"
                                    ? _vm.isDifferent(true, true, true)
                                    : "",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.City") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("City")))]
                            ),
                            _c("el-input", {
                              class: _vm.cityMaxLength(
                                _vm.addressForm.sellerCity
                              ),
                              attrs: { no: "20" },
                              model: {
                                value: _vm.addressForm.sellerCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "sellerCity", $$v)
                                },
                                expression: "addressForm.sellerCity"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, true, false)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("ZIP"),
                          title: _vm.$t("SeaExport.ZIP")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              class: _vm.zipMaxLength(
                                _vm.addressForm.sellerPostalcode
                              ),
                              attrs: { no: "21" },
                              model: {
                                value: _vm.addressForm.sellerPostalcode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "sellerPostalcode",
                                    $$v
                                  )
                                },
                                expression: "addressForm.sellerPostalcode"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Province") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                            ),
                            _c("el-input", {
                              class: _vm.stateMaxLength(
                                _vm.addressForm.sellerProvince
                              ),
                              attrs: { no: "22" },
                              model: {
                                value: _vm.addressForm.sellerProvince,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "sellerProvince",
                                    $$v
                                  )
                                },
                                expression: "addressForm.sellerProvince"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, false, true)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("Email"),
                          title: _vm.$t("SeaExport.Email")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              class: _vm.emailMaxLength(
                                _vm.addressForm.sellerEmail
                              ),
                              attrs: { no: "23" },
                              model: {
                                value: _vm.addressForm.sellerEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "sellerEmail", $$v)
                                },
                                expression: "addressForm.sellerEmail"
                              }
                            }),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.form.frob === "I"
                                    ? _vm.isDifferent(false, false, true)
                                    : "",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Tel") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                            ),
                            _c("el-input", {
                              class: _vm.telMaxLength(
                                _vm.addressForm.sellerTel
                              ),
                              attrs: {
                                placeholder:
                                  !_vm.readonly && _vm.isEFreight
                                    ? _vm.$t("SeaExport.TelSeparate")
                                    : "",
                                no: "24"
                              },
                              model: {
                                value: _vm.addressForm.sellerTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "sellerTel", $$v)
                                },
                                expression: "addressForm.sellerTel"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isYitong,
                            expression: "!isYitong"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Contact Name") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": _vm.contactNameMaxLength,
                            "is-trim": true,
                            no: "25"
                          },
                          model: {
                            value: _vm.addressForm.sellerContactName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.addressForm,
                                "sellerContactName",
                                $$v
                              )
                            },
                            expression: "addressForm.sellerContactName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Type Of Person") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "26" },
                            model: {
                              value: _vm.addressForm.sellerTypeOfPerson,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "sellerTypeOfPerson",
                                  $$v
                                )
                              },
                              expression: "addressForm.sellerTypeOfPerson"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("NATURAL"),
                                value: "1"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("LEGAL"),
                                value: "2"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("ASSOCIATION"),
                                value: "3"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("EORI") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 17,
                            "is-trim": true,
                            no: "27"
                          },
                          model: {
                            value: _vm.addressForm.sellerEori,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "sellerEori", $$v)
                            },
                            expression: "addressForm.sellerEori"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Buyer") } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "vertical-align": "top" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "28",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyAddress("Buyer")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopConsignee")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.Name") } },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.form.frob === "I"
                                ? _vm.isDifferent(true, true, true)
                                : "",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Name")))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "29"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog("buyer", 2)
                            }
                          },
                          model: {
                            value: _vm.addressForm.buyerName,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerName", $$v)
                            },
                            expression: "addressForm.buyerName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.Addr") + "1" } },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.form.frob === "I"
                                ? _vm.isDifferent(true, true, true)
                                : "",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address") + "1"))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "30"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog("buyer", 2)
                            }
                          },
                          model: {
                            value: _vm.addressForm.buyerAddress1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerAddress1", $$v)
                            },
                            expression: "addressForm.buyerAddress1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Address") + "2",
                          title: _vm.$t("SeaExport.Addr") + "2"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address") + "2"))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 40,
                            "is-trim": true,
                            no: "31"
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog("buyer", 3)
                            }
                          },
                          model: {
                            value: _vm.addressForm.buyerAddress2,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerAddress2", $$v)
                            },
                            expression: "addressForm.buyerAddress2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isTradetech,
                            expression: "!isTradetech"
                          }
                        ],
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(true, true, true)
                            : "",
                        attrs: { label: _vm.getItemTitle("Street No") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "32" },
                          model: {
                            value: _vm.addressForm.buyerStreetNo,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerStreetNo", $$v)
                            },
                            expression: "addressForm.buyerStreetNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, false, true)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("Country"),
                          title: _vm.$t("SeaExport.Country")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "33",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Country,
                                cache: false,
                                filterable: "",
                                "default-value": _vm.addressForm.buyerCountry,
                                "filter-tag-names": [
                                  "code",
                                  "chineseName",
                                  "name"
                                ],
                                "tag-name": "code",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.addressForm.buyerCountry = p.value
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.form.frob === "I"
                                    ? _vm.isDifferent(true, true, true)
                                    : "",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.City") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("City")))]
                            ),
                            _c("el-input", {
                              class: _vm.cityMaxLength(
                                _vm.addressForm.buyerCity
                              ),
                              attrs: { no: "34" },
                              model: {
                                value: _vm.addressForm.buyerCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "buyerCity", $$v)
                                },
                                expression: "addressForm.buyerCity"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, true, false)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("ZIP"),
                          title: _vm.$t("SeaExport.ZIP")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              class: _vm.zipMaxLength(
                                _vm.addressForm.buyerPostalcode
                              ),
                              attrs: { no: "35" },
                              model: {
                                value: _vm.addressForm.buyerPostalcode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "buyerPostalcode",
                                    $$v
                                  )
                                },
                                expression: "addressForm.buyerPostalcode"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Province") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                            ),
                            _c("el-input", {
                              class: _vm.stateMaxLength(
                                _vm.addressForm.buyerProvince
                              ),
                              attrs: { no: "36" },
                              model: {
                                value: _vm.addressForm.buyerProvince,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "buyerProvince",
                                    $$v
                                  )
                                },
                                expression: "addressForm.buyerProvince"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.frob === "I"
                            ? _vm.isDifferent(false, false, true)
                            : "",
                        attrs: {
                          label: _vm.getItemTitle("Email"),
                          title: _vm.$t("SeaExport.Email")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              class: _vm.emailMaxLength(
                                _vm.addressForm.buyerEmail
                              ),
                              attrs: { no: "37" },
                              model: {
                                value: _vm.addressForm.buyerEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "buyerEmail", $$v)
                                },
                                expression: "addressForm.buyerEmail"
                              }
                            }),
                            _c(
                              "span",
                              {
                                class:
                                  _vm.form.frob === "I"
                                    ? _vm.isDifferent(false, false, true)
                                    : "",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Tel") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                            ),
                            _c("el-input", {
                              class: _vm.telMaxLength(_vm.addressForm.buyerTel),
                              attrs: {
                                placeholder:
                                  !_vm.readonly && _vm.isEFreight
                                    ? _vm.$t("SeaExport.TelSeparate")
                                    : "",
                                no: "38"
                              },
                              model: {
                                value: _vm.addressForm.buyerTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "buyerTel", $$v)
                                },
                                expression: "addressForm.buyerTel"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isYitong,
                            expression: "!isYitong"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Contact Name") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": _vm.contactNameMaxLength,
                            "is-trim": true,
                            no: "39"
                          },
                          model: {
                            value: _vm.addressForm.buyerContactName,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerContactName", $$v)
                            },
                            expression: "addressForm.buyerContactName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Type Of Person") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "40" },
                            model: {
                              value: _vm.addressForm.buyerTypeOfPerson,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "buyerTypeOfPerson",
                                  $$v
                                )
                              },
                              expression: "addressForm.buyerTypeOfPerson"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("NATURAL"),
                                value: "1"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("LEGAL"),
                                value: "2"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.getItemTitle("ASSOCIATION"),
                                value: "3"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("EORI") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 17,
                            "is-trim": true,
                            no: "41"
                          },
                          model: {
                            value: _vm.addressForm.buyerEori,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "buyerEori", $$v)
                            },
                            expression: "addressForm.buyerEori"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isYitong,
                            expression: "isYitong"
                          }
                        ]
                      },
                      [
                        _c("el-form-item", {
                          attrs: { label: _vm.getItemTitle("Representative") }
                        }),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Name"),
                              title: _vm.$t("SeaExport.Name")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "76" },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showSenderAndReceiverDialog(
                                    "representative",
                                    2
                                  )
                                }
                              },
                              model: {
                                value: _vm.addressForm.representativeName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "representativeName",
                                    $$v
                                  )
                                },
                                expression: "addressForm.representativeName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Address") + "1",
                              title: _vm.$t("SeaExport.Addr") + "1"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "77" },
                              model: {
                                value: _vm.addressForm.representativeAddress1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "representativeAddress1",
                                    $$v
                                  )
                                },
                                expression: "addressForm.representativeAddress1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Address") + "2",
                              title: _vm.$t("SeaExport.Addr") + "2"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "78" },
                              model: {
                                value: _vm.addressForm.representativeAddress2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "representativeAddress2",
                                    $$v
                                  )
                                },
                                expression: "addressForm.representativeAddress2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("Street No") } },
                          [
                            _c("el-input", {
                              attrs: { no: "79" },
                              model: {
                                value: _vm.addressForm.representativeStreetNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "representativeStreetNo",
                                    $$v
                                  )
                                },
                                expression: "addressForm.representativeStreetNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Country"),
                              title: _vm.$t("SeaExport.Country")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "88",
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Country,
                                    cache: false,
                                    filterable: "",
                                    "default-value":
                                      _vm.addressForm.representativeCountry,
                                    "filter-tag-names": [
                                      "code",
                                      "chineseName",
                                      "name"
                                    ],
                                    "tag-name": "code",
                                    "tag-value": "code"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.addressForm.representativeCountry =
                                        p.value
                                    }
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "center-label",
                                    attrs: { title: _vm.$t("SeaExport.City") }
                                  },
                                  [_vm._v(_vm._s(_vm.getItemTitle("City")))]
                                ),
                                _c("el-input", {
                                  attrs: { no: "80" },
                                  model: {
                                    value: _vm.addressForm.representativeCity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "representativeCity",
                                        $$v
                                      )
                                    },
                                    expression: "addressForm.representativeCity"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("ZIP"),
                              title: _vm.$t("SeaExport.ZIP")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  attrs: { no: "81" },
                                  model: {
                                    value:
                                      _vm.addressForm.representativePostalcode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "representativePostalcode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "addressForm.representativePostalcode"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "5px",
                                      "margin-right": "5px",
                                      width: "110px"
                                    },
                                    attrs: {
                                      title: _vm.$t("SeaExport.Province")
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                                ),
                                _c("el-input", {
                                  attrs: { no: "82" },
                                  model: {
                                    value:
                                      _vm.addressForm.representativeProvince,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "representativeProvince",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "addressForm.representativeProvince"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Email"),
                              title: _vm.$t("SeaExport.Email")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  attrs: { no: "83" },
                                  model: {
                                    value: _vm.addressForm.representativeEmail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "representativeEmail",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "addressForm.representativeEmail"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "5px",
                                      "margin-right": "5px",
                                      width: "110px"
                                    },
                                    attrs: { title: _vm.$t("SeaExport.Tel") }
                                  },
                                  [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                                ),
                                _c("el-input", {
                                  attrs: {
                                    placeholder:
                                      !_vm.readonly && _vm.isEFreight
                                        ? _vm.$t("SeaExport.TelSeparate")
                                        : "",
                                    no: "87"
                                  },
                                  model: {
                                    value: _vm.addressForm.representativeTel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "representativeTel",
                                        $$v
                                      )
                                    },
                                    expression: "addressForm.representativeTel"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm.isYitong
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.getItemTitle("Representative type")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { no: "85" },
                                    model: {
                                      value:
                                        _vm.addressForm
                                          .representativeTypeOfPerson,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "representativeTypeOfPerson",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addressForm.representativeTypeOfPerson"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.DirectlyRepresenting"
                                        ),
                                        value: "2"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.IndirectRepresentation"
                                        ),
                                        value: "3"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.getItemTitle("Type Of Person")
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { no: "85" },
                                    model: {
                                      value:
                                        _vm.addressForm
                                          .representativeTypeOfPerson,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "representativeTypeOfPerson",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addressForm.representativeTypeOfPerson"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.getItemTitle("NATURAL"),
                                        value: "1"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.getItemTitle("LEGAL"),
                                        value: "2"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.getItemTitle("ASSOCIATION"),
                                        value: "3"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("EORI") } },
                          [
                            _c("el-input", {
                              attrs: { no: "86" },
                              model: {
                                value: _vm.addressForm.representativeEori,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "representativeEori",
                                    $$v
                                  )
                                },
                                expression: "addressForm.representativeEori"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticStyle: { "margin-bottom": "10px" } })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !(_vm.isF16F17 && _vm.isYitong),
                    expression: "!(isF16F17 && isYitong)"
                  }
                ],
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "120px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title: _vm.$t("SeaExport.TransportationInformation")
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipping Information")))]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.EnsNo") } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v("ENS NO")]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": _vm.ensNoMaxLength,
                            "is-trim": true,
                            no: "42"
                          },
                          on: { blur: _vm.hblNbr2Change },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: _vm.$t("SeaExport.MBLNumber") } },
                      [
                        _c(
                          "span",
                          {
                            class: _vm.isDifferent(true, true, true),
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("MB/L NO")))]
                        ),
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": _vm.mblMaxLength,
                            "is-trim": true,
                            no: "43"
                          },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.isF16F17 && _vm.isEFreight),
                            expression: "!(isF16F17 && isEFreight)"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent(true, false, false),
                            attrs: {
                              label: _vm.getItemTitle("Vessel"),
                              title: _vm.$t("SeaExport.ShipName")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.static_data_Vessel,
                                cache: false,
                                "allow-create": true,
                                filterable: "",
                                "default-value": _vm.form.vessel,
                                "static-options": _vm.localData.vesselList,
                                no: "44"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.onVesselSelectionChange(p)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { title: _vm.$t("SeaExport.Voyage") } },
                          [
                            _c("template", { slot: "label" }, [
                              _c(
                                "span",
                                { class: _vm.isDifferent(true, false, false) },
                                [_vm._v(_vm._s(_vm.getItemTitle("Voyage")))]
                              )
                            ]),
                            _c("cargo-rich-textarea", {
                              staticStyle: { "min-height": "unset" },
                              attrs: {
                                disabled: _vm.readonly,
                                "max-count": _vm.voyageMaxLength,
                                "is-trim": true,
                                no: "45"
                              },
                              on: {
                                change: _vm.changeVoyage,
                                blur: _vm.voyageFlightBlur
                              },
                              model: {
                                value: _vm.form.voyageFlight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "voyageFlight", $$v)
                                },
                                expression: "form.voyageFlight"
                              }
                            })
                          ],
                          2
                        ),
                        _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent(true, false, false),
                            attrs: {
                              label: _vm.getItemTitle("IMO"),
                              title: _vm.$t("SeaExport.ShipNumber")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { maxlength: _vm.imoMaxLength, no: "46" },
                              model: {
                                value: _vm.form.vesselIMO,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "vesselIMO", $$v)
                                },
                                expression: "form.vesselIMO"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, false, false),
                        attrs: {
                          label: _vm.getItemTitle("ETD"),
                          title: _vm.$t("SeaExport.DateOfDeparture")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "47"
                          },
                          model: {
                            value: _vm.form.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "etd", $$v)
                            },
                            expression: "form.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, false, false),
                        attrs: {
                          label: _vm.getItemTitle("ETA"),
                          title: _vm.$t("SeaExport.ArrivalDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "48"
                          },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isTradetech,
                            expression: "isTradetech"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Deliv.Mode") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightTerm",
                            filterable: "",
                            "default-value": _vm.form.freightTermHBL,
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options":
                              _vm.SystemConstants.AMS_FREIGHT_TERM
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.freightTermHBL = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isShow(true, false, true) &&
                              !(_vm.isF16F17 && _vm.isEFreight),
                            expression:
                              "isShow(true,false,true) && !(isF16F17 && isEFreight)"
                          }
                        ],
                        class: _vm.isDifferent(true, false, false),
                        attrs: {
                          label: _vm.getItemTitle("Place of Receipt"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDispatch")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dispatchingPlaceCode,
                            "tag-name": "englishName",
                            no: "49"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dispatchingPlaceCode",
                                "dispatchingPlace"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, true),
                        attrs: {
                          label: _vm.getItemTitle("Place of Loading"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDeparture")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.loadingPortCode || "",
                            "tag-name": "englishName",
                            no: "50"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "loadingPortCode",
                                "loadingPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, true),
                        attrs: {
                          label: _vm.getItemTitle("Place of Discharge"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDischarge")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dischargingPortCode || "",
                            "tag-name": "englishName",
                            no: "51"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dischargingPortCode",
                                "dischargingPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.isF16F17 && _vm.isEFreight),
                            expression: "!(isF16F17 && isEFreight)"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent(true, false, false),
                            attrs: {
                              label: _vm.getItemTitle("Place Of Delivery"),
                              title: _vm.$t(
                                "SeaExport.BillLadingPlaceOfDelivery"
                              )
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value":
                                  _vm.form.destinationPortCode || "",
                                "tag-name": "englishName",
                                no: "52"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "destinationPortCode",
                                    "destinationPort"
                                  )
                                }
                              }
                            }),
                            _c("el-input", {
                              model: {
                                value: _vm.form.destinationPort,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "destinationPort", $$v)
                                },
                                expression: "form.destinationPort"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShow(false, false, true),
                                expression: "isShow(false,false,true)"
                              }
                            ],
                            class: _vm.isDifferent(false, false, true),
                            attrs: {
                              label: _vm.getItemTitle("First Port of Call"),
                              title: _vm.$t("SeaExport.FirstPortOfCall")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                "default-value": _vm.form.firstPortOfCallCode,
                                no: "53"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "firstPortOfCallCode",
                                    "firstPortOfCall"
                                  )
                                }
                              }
                            }),
                            _c("el-input", {
                              model: {
                                value: _vm.form.firstPortOfCall,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "firstPortOfCall", $$v)
                                },
                                expression: "form.firstPortOfCall"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShow(false, false, true),
                                expression: "isShow(false,false,true)"
                              }
                            ],
                            attrs: {
                              label: _vm.getItemTitle("Last Foreign Port"),
                              title: _vm.$t("SeaExport.LastOverseasPort")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                "default-value": _vm.form.lastAbroadProd,
                                no: "54"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "lastAbroadProd",
                                    "lastAbroadProdName"
                                  )
                                }
                              }
                            }),
                            _c("el-input", {
                              model: {
                                value: _vm.form.lastAbroadProdName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "lastAbroadProdName", $$v)
                                },
                                expression: "form.lastAbroadProdName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShow(true, true, false),
                                expression: "isShow(true,true,false)"
                              }
                            ]
                          },
                          [
                            _c(
                              "span",
                              { class: _vm.isDifferent(true, true, false) },
                              [_vm._v(_vm._s(_vm.getItemTitle("RouteCountry")))]
                            ),
                            _c("br"),
                            _c("br"),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.readonly,
                                  size: "mini",
                                  type: "primary"
                                },
                                on: { click: _vm.addRouteCountry }
                              },
                              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.readonly,
                                  size: "mini",
                                  type: "primary"
                                },
                                on: { click: _vm.deleteRouteCountry }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Delete"))
                                )
                              ]
                            ),
                            _c("cargo-ag-grid", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "grid-options": _vm.routeCountry.gridOptions,
                                "column-defs": _vm.columnDefs,
                                "row-data": _vm.form.routeCountryList,
                                "show-side-bar": false
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.gridApi = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isF14 || _vm.isTradetech,
                            expression: "isF14 || isTradetech"
                          }
                        ]
                      },
                      [
                        _c("br"),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShow(true, false, false),
                                expression: "isShow(true,false,false)"
                              }
                            ],
                            staticClass: "blue-text",
                            attrs: {
                              label: _vm.getItemTitle(
                                "ColoadInSelfFilingIndicator"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px", float: "right" },
                                attrs: { no: "55" },
                                model: {
                                  value: _vm.form.coloadInSelfFilingIndicator,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "coloadInSelfFilingIndicator",
                                      $$v
                                    )
                                  },
                                  expression: "form.coloadInSelfFilingIndicator"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.yes"),
                                    value: true
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.no"),
                                    value: false
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("br"),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.coloadInSelfFilingIndicator ||
                                  _vm.isTradetech ||
                                  _vm.isYitong,
                                expression:
                                  "form.coloadInSelfFilingIndicator || isTradetech || isYitong"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.readonly,
                                  size: "mini",
                                  type: "primary"
                                },
                                on: { click: _vm.addRouteCountry2 }
                              },
                              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.readonly,
                                  size: "mini",
                                  type: "primary"
                                },
                                on: { click: _vm.deleteRouteCountry2 }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Delete"))
                                )
                              ]
                            ),
                            _c("cargo-ag-grid", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "grid-options":
                                  _vm.coloadInSelfFilingIndicator.gridOptions,
                                "column-defs": _vm.columnDefs2,
                                "row-data": _vm.form.ensDeclarationData,
                                "show-side-bar": false
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.gridApi2 = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isF16F17 && _vm.isYitong,
                    expression: "(isF16F17 && isYitong)"
                  }
                ],
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "120px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title: _vm.$t("SeaExport.TransportationInformation")
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipping Information")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isF17,
                            expression: "!isF17"
                          }
                        ],
                        staticClass: "blue-text",
                        attrs: {
                          label: "ENS NO",
                          title: _vm.$t("SeaExport.EnsNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "42" },
                          on: { input: _vm.hblNbr2Change },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, true),
                        attrs: {
                          label: _vm.getItemTitle("MB/L NO"),
                          title: _vm.$t("SeaExport.MBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "43" },
                          on: { change: _vm.mblChange },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isYitong,
                    expression: "isYitong"
                  }
                ],
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "title",
                    attrs: { title: _vm.$t("SeaExport.Other") }
                  },
                  [_vm._v(_vm._s(_vm.getItemTitle("Other")))]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-position": "right",
                      "label-width": "110px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Declarant") } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "vertical-align": "top" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "14",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyAddress("Carrier")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyConsignor")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "vertical-align": "top" },
                            attrs: { no: "2", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CodeSearching")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Name"),
                          title: _vm.$t("SeaExport.Name")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "56" },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "carrier",
                                2
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.carrierName,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "carrierName", $$v)
                            },
                            expression: "addressForm.carrierName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Address") + "1",
                          title: _vm.$t("SeaExport.Addr") + "1"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "57" },
                          model: {
                            value: _vm.addressForm.carrierAddress1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "carrierAddress1", $$v)
                            },
                            expression: "addressForm.carrierAddress1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Address") + "2",
                          title: _vm.$t("SeaExport.Addr") + "2"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "58" },
                          model: {
                            value: _vm.addressForm.carrierAddress2,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "carrierAddress2", $$v)
                            },
                            expression: "addressForm.carrierAddress2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.getItemTitle("Street No") } },
                      [
                        _c("el-input", {
                          attrs: { no: "59" },
                          model: {
                            value: _vm.addressForm.carrierStreetNo,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "carrierStreetNo", $$v)
                            },
                            expression: "addressForm.carrierStreetNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Country"),
                          title: _vm.$t("SeaExport.Country")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "60",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Country,
                                cache: false,
                                filterable: "",
                                "default-value": _vm.addressForm.carrierCountry,
                                "filter-tag-names": [
                                  "code",
                                  "chineseName",
                                  "name"
                                ],
                                "tag-name": "code",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.addressForm.carrierCountry = p.value
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "center-label",
                                attrs: { title: _vm.$t("SeaExport.City") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("City")))]
                            ),
                            _c("el-input", {
                              attrs: { no: "61" },
                              model: {
                                value: _vm.addressForm.carrierCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "carrierCity", $$v)
                                },
                                expression: "addressForm.carrierCity"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("ZIP"),
                          title: _vm.$t("SeaExport.ZIP")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              attrs: { no: "62" },
                              model: {
                                value: _vm.addressForm.carrierPostalcode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "carrierPostalcode",
                                    $$v
                                  )
                                },
                                expression: "addressForm.carrierPostalcode"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Province") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                            ),
                            _c("el-input", {
                              attrs: { no: "63" },
                              model: {
                                value: _vm.addressForm.carrierProvince,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "carrierProvince",
                                    $$v
                                  )
                                },
                                expression: "addressForm.carrierProvince"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Email"),
                          title: _vm.$t("SeaExport.Email")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              attrs: { no: "64" },
                              model: {
                                value: _vm.addressForm.carrierEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "carrierEmail", $$v)
                                },
                                expression: "addressForm.carrierEmail"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px",
                                  width: "110px"
                                },
                                attrs: { title: _vm.$t("SeaExport.Tel") }
                              },
                              [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                            ),
                            _c("el-input", {
                              attrs: {
                                placeholder:
                                  !_vm.readonly && _vm.isEFreight
                                    ? _vm.$t("SeaExport.TelSeparate")
                                    : "",
                                no: "65"
                              },
                              model: {
                                value: _vm.addressForm.carrierTel,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "carrierTel", $$v)
                                },
                                expression: "addressForm.carrierTel"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticStyle: { "margin-bottom": "10px" } })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !(_vm.isF16F17 && _vm.isYitong),
                expression: "!(isF16F17 && isYitong)"
              }
            ],
            staticClass: "section"
          },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: { title: _vm.$t("SeaExport.CargoInfo") }
              },
              [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    staticStyle: { padding: "5px 0" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "69"
                        },
                        on: { click: _vm.addCargoInfo }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.RemoveContainerInformation"),
                          no: "70"
                        },
                        on: { click: _vm.deleteCargoInfo }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: {
                    "config-module": "131702",
                    "grid-options": _vm.cargoInfomation.gridOptions,
                    "column-defs": _vm.cargoInformationColumnDefs,
                    "row-data": _vm.form.ensCargoInfo
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi3 = params.api
                    }
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !(_vm.isF16F17 && _vm.isYitong),
                expression: "!(isF16F17 && isYitong)"
              }
            ],
            staticClass: "section"
          },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
              },
              [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    staticStyle: { padding: "5px 0" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "71"
                        },
                        on: {
                          click: function($event) {
                            _vm.cargoDocUsageSelectedDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.RemoveContainerInformation"),
                          no: "72"
                        },
                        on: { click: _vm.removeContainerUsageClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: {
                    "config-module": "131701",
                    "grid-options": _vm.container.gridOptions,
                    "column-defs": _vm.containerColumnDefs,
                    "row-data": _vm.containerFinalRowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.container.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": _vm.advanceTextDialog.warningCount,
              disabled: _vm.readonly,
              no: "73"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "74" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "75" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptInfoDialog.visible,
            title: _vm.receiptInfoDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptInfoDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptInfoDialog.gridOptions,
              "column-defs": _vm.receiptInfoDialog.columnDefs,
              "row-data": _vm.receiptInfoDialog.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.receiptInfoDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("cargo-doc-usage-selected-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.AMS
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _c("ams-log-view-title-dialog", {
        attrs: {
          visible: _vm.amsLogViewTitleDialog.visible,
          "row-data": _vm.amsLogViewTitleDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.amsLogViewTitleDialog, "visible", $event)
          }
        }
      }),
      _c("afr-address-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params,
          "no-label": _vm.amsTitle,
          "no-title": _vm.amsTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }